import type { FC } from "react";
import { BabyListInitScript, showBabyListButton } from "../../utils/babylist";

const PageFoot: FC = () => {
	return <>{showBabyListButton() && <BabyListInitScript />}</>;
};

export default PageFoot;
